<form class="form-validation" *ngIf="lang">
  <div style="width: 100% !important;">
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ modalTitle }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="table-responsive" style="overflow: auto;">
      <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover"
                        id="table1">
                        <thead>
                          <tr>
                            <th>{{ lang.sno }}</th>
                            <th>{{ lang.name }}</th>
                            <th>{{ lang.surname }}</th>
                            <th>{{ lang.age }}</th>
                            <th>{{ lang.email }}</th>
                            <th>{{ lang.phone }}</th>
                            <th>{{ lang.task }}</th>
                            <th>{{ lang.qualifications }}</th>
                            <th>{{ lang.assumptionData }}</th>
                            <th style="display: none;">{{ lang.taxCode }}</th>
                            <th style="display: none;">{{ lang.dateofBirth }}</th>
                            <th style="display: none;">{{ lang.placeofBirth }}</th>
                            <th style="display: none;">{{ lang.address }}</th>
                            <th style="display: none;">{{ lang.titleofStudy }}</th>
                            <th style="display: none;">{{ lang.hourlyCost }}</th>
                            <th>{{ lang.status }}</th>
                          </tr>
                        </thead>
                        <tbody dragula="records" [(dragulaModel)]="records">
                          <tr *ngFor="let record of records let i = index" id="{{record.employeeId}}">
                            <td>{{i+1}}</td>
                            <td><a [routerLink]="['/'+AppFrontRoutes.EMPLOYEE_VIEW+'/'+record.employeeId]">{{record.employee_name}}</a></td>
                            <td>{{record.employee_surname}}</td>
                            <td>{{record.age}}</td>
                            <td>{{record.employee_email}}</td>
                            <td>{{record.employee_phone}}</td>
                            <td>{{record.employee_task}}</td>
                            <td>{{record.employee_qualification}}</td>
                            <td>{{record.employee_assumption_date}}</td>
                            <td style="display: none;">{{record.employee_tax_code}}</td>
                            <td style="display: none;">{{record.emp_dob}}</td>
                            <td style="display: none;">{{record.employee_placeOfbirth}}</td>
                            <td style="display: none;">{{record.employee_address}}</td>
                            <td style="display: none;">{{record.employee_timeOfstudy}}</td>
                            <td style="display: none;">{{record.employee_houly_cost}}</td>
                            <td>
                              <div [innerHTML]="record.status"></div>
                            </td>
                          </tr>
                        </tbody>

                      </table>
    </div>
  </div>

</div>
</form>
